import { useState, useContext } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsEyeFill, BsPlusCircle } from 'react-icons/bs';
import { Button } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';
import { AiFillFileText } from 'react-icons/ai';

import styles from '../../PositionLine/PositionLine.module.scss';
import useDetailsEventsModal from '../../../../../hooks/useDetailsEventsModal';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import FilesModal from '../../../../../page/ServiceRequest/DetailServiceRequest/TabsDetail/PteAutorizar/FilesModal/FilesModal';
import { FilesSdsPtContext } from '../../../../../context/FilesSdsPtContext';
import { parseDateFormat } from '../../../utils/date';
import { checkRol } from '../../../../../security';
import { aprobador, inspector } from '../../../../../security/constantsRols';

import ModalImputationObjectVE from './ImputationObjectModal/ModalImputationObjectVE';

const SubHeader = ({
  showHeader,
  titleSortBy,
  title,
  sortType,
  secondColumnData,
  requestData,
  dateEnd,
  dateInit,
  handleReloadTable
}) => {
  const { activeImputationObjectModal } = useWorkReportModals();
  const [showFilesModal, setShowFilesModal] = useState(false);
  const [showImputationObjectModal, setShowImputationObjectModal] = useState(false);
  const { setDateFilterRange, dataFilesPt } = useContext(FilesSdsPtContext);
  const [loading, setLoading] = useState(false);
  const isApprover = checkRol(aprobador);
  const isInspector = checkRol(inspector);

  const {
    handleShowDetailsEventsModal,
    handleOperations,
    handleHasTechnicalLocations,
    handleTitleModal
  } = useDetailsEventsModal();

  const handleSetTitleModal = () => {
    handleTitleModal({
      title: requestData.nroSolicitud
    });
  };

  const handleShowFilesModal = async () => {
    setShowFilesModal(true);
    setDateFilterRange({
      startDateLimit: dateInit.split('T')[0],
      finalDateLimit: dateEnd.split('T')[0]
    });
  };

  return (
    <>
      {showHeader && (
        <tr>
          <td colSpan={2}>
            {showHeader &&
              (sortType === 'provider' ? (
                <div
                  className={`${styles['header-container']} ${styles['header-container-sub-header']}`}
                >
                  <div className={styles['header-location-group']}>
                    <span>Ubicación</span>
                    {titleSortBy?.length > 25 ? (
                      <OverlayTrigger
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="sort-title-tooltip">{titleSortBy}</Tooltip>}
                        placement="top"
                      >
                        <span>{titleSortBy}</span>
                      </OverlayTrigger>
                    ) : (
                      <span>{titleSortBy}</span>
                    )}
                  </div>
                  {!!title && (
                    <div className={styles['header-location-group']}>
                      <span>Equipo</span>
                      {title?.length > 13 ? (
                        <OverlayTrigger
                          delay={{ show: 250, hide: 400 }}
                          overlay={<Tooltip id="title-tooltip">{title}</Tooltip>}
                          placement="top"
                        >
                          <span>{title}</span>
                        </OverlayTrigger>
                      ) : (
                        <span>{title}</span>
                      )}
                    </div>
                  )}
                  {!!requestData?.objetoImputacion && isInspector && (
                    <button
                      onClick={() =>
                        activeImputationObjectModal({
                          imputationObject: requestData?.objetoImputacion,
                          requestNumber: requestData?.nroSolicitud,
                          titleUbication: requestData?.agrupadoPor,
                          monthlyRequest: requestData?.solicitudMensualizada,
                          dateEnd,
                          dateInit,
                          idSolicitud: requestData?.idSolicitud,
                          proveedor: requestData?.primerAgrupador,
                          idUbicacion: requestData?.idUbicacion
                        })
                      }
                      style={{
                        color: '#0063bd',
                        fontWeight: '600'
                      }}
                      type="button"
                    >
                      <span>
                        {requestData?.objetoImputacion}{' '}
                        {!!requestData?.objetoImputacionModificado && '+'}
                      </span>
                    </button>
                  )}

                  {!!requestData?.objetoImputacion && isApprover && (
                    <>
                      <button
                        onClick={() => {
                          setShowImputationObjectModal(true);
                        }}
                        style={{
                          color: '#0063bd',
                          fontWeight: '600'
                        }}
                        type="button"
                      >
                        <span>{requestData?.objetoImputacion} </span>
                      </button>
                      {!!requestData?.objetoImputacionModificado && (
                        <button
                          aria-label="ver-objecto-imputacion"
                          className="text-primary"
                          onClick={() => {
                            activeImputationObjectModal({
                              imputationObject: requestData?.objetoImputacion,
                              requestNumber: requestData?.nroSolicitud,
                              titleUbication: requestData?.agrupadoPor,
                              monthlyRequest: requestData?.solicitudMensualizada,
                              dateEnd,
                              dateInit,
                              idSolicitud: requestData?.idSolicitud,
                              proveedor: requestData?.primerAgrupador,
                              idUbicacion: requestData?.idUbicacion
                            });
                          }}
                          style={{
                            paddingLeft: '15px'
                          }}
                          type="button"
                        >
                          <BsPlusCircle size={20} />
                        </button>
                      )}
                    </>
                  )}
                  <Button
                    className="eye-button"
                    colorIcon={!requestData?.contieneArchivosAdjuntos ? 'secondary' : 'primary'}
                    disabled={!requestData?.contieneArchivosAdjuntos}
                    icon={AiFillFileText}
                    onClick={handleShowFilesModal}
                    sizeIcon="20px"
                    type="button"
                    widthButton="40px"
                  />
                </div>
              ) : (
                <div className={`${styles['header-container']} ${styles['header-provider']}`}>
                  {titleSortBy?.length > 20 ? (
                    <OverlayTrigger
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id="sort-title-tooltip">{titleSortBy}</Tooltip>}
                      placement="top"
                    >
                      <span>{titleSortBy}</span>
                    </OverlayTrigger>
                  ) : (
                    <span>{titleSortBy}</span>
                  )}
                  {title?.length > 15 ? (
                    <OverlayTrigger
                      delay={{ show: 250, hide: 400 }}
                      overlay={<Tooltip id="title-tooltip">{title}</Tooltip>}
                      placement="top"
                    >
                      <span>{title}</span>
                    </OverlayTrigger>
                  ) : (
                    <span>{title}</span>
                  )}

                  <div className="d-flex justify-content-center">
                    {!handleHasTechnicalLocations({ headData: secondColumnData }) && (
                      <Button
                        className="eye-button"
                        colorIcon="primary"
                        icon={BsEyeFill}
                        onClick={() => {
                          handleSetTitleModal();
                          handleShowDetailsEventsModal({ showModal: true });
                          handleOperations({ requestData, isFromVE: true });
                        }}
                        sizeIcon="20px"
                        type="button"
                        widthButton="40px"
                      />
                    )}
                    <Button
                      className="eye-button"
                      colorIcon={!requestData?.contieneArchivosAdjuntos ? 'secondary' : 'primary'}
                      disabled={!requestData?.contieneArchivosAdjuntos}
                      icon={AiFillFileText}
                      onClick={handleShowFilesModal}
                      sizeIcon="20px"
                      type="button"
                      widthButton="40px"
                    />
                  </div>
                </div>
              ))}
            {showFilesModal && (
              <FilesModal
                dataFiles={dataFilesPt}
                details={{
                  id: requestData?.idSolicitud,
                  dateEnd: parseDateFormat(dateEnd),
                  dateInit: parseDateFormat(dateInit),
                  tipoAsignacion: requestData?.tipoAsignacion,
                  requestData
                }}
                hideModal={() => setShowFilesModal(false)}
                loading={loading}
                setLoading={setLoading}
                showFilters
                showModal={showFilesModal}
              />
            )}
          </td>
        </tr>
      )}
      {showImputationObjectModal && (
        <ModalImputationObjectVE
          fechaRealizacionDesde={dateInit}
          fechaRealizacionHasta={dateEnd}
          handleReloadTable={handleReloadTable}
          idSolicitud={requestData?.idSolicitud}
          idUbicacion={requestData?.idUbicacion}
          idsParteDiario={requestData?.idParteDiario}
          isMSDS={requestData?.solicitudMensualizada}
          nroLinea={Number(requestData?.numeroPosicion)}
          nroPosicion={Number(requestData?.numeroLinea)}
          setShowModal={setShowImputationObjectModal}
          showModal={showImputationObjectModal}
          tipoUbicacionEnum={requestData?.tipoUbicacionEnum}
          title={titleSortBy}
          ubicacion={requestData?.ubicacion}
        />
      )}
    </>
  );
};

export default SubHeader;

SubHeader.propTypes = {
  showHeader: PropTypes.bool.isRequired,
  sortType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleSortBy: PropTypes.string.isRequired,
  requestData: PropTypes.shape({
    nroSolicitud: PropTypes.string,
    objetoImputacion: PropTypes.string,
    objetoImputacionModificado: PropTypes.bool,
    agrupadoPor: PropTypes.string,
    primerAgrupador: PropTypes.string,
    solicitudMensualizada: PropTypes.bool,
    idSolicitud: PropTypes.number,
    idUbicacion: PropTypes.number,
    contieneArchivosAdjuntos: PropTypes.bool,
    tipoAsignacion: PropTypes.shape({}),
    idParteDiario: PropTypes.number,
    numeroPosicion: PropTypes.number,
    numeroLinea: PropTypes.number,
    tipoUbicacionEnum: PropTypes.number,
    ubicacion: PropTypes.string
  }).isRequired,
  secondColumnData: PropTypes.shape({}).isRequired,
  dateInit: PropTypes.string.isRequired,
  dateEnd: PropTypes.string.isRequired,
  handleReloadTable: PropTypes.func
};

SubHeader.defaultProps = {
  handleReloadTable: () => {}
};
